var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("article", { staticClass: "nti-product-tile-grid" }, [
    _c(
      "section",
      { staticClass: "nti-product-tile-grid__navigation-container" },
      [
        _c(
          "div",
          { staticClass: "nti-product-tile-grid__mobile-filter" },
          [_c("ShopFilter")],
          1
        ),
        _vm._v(" "),
        _c("SortDropdown"),
        _vm._v(" "),
        _c("FilterPager", {
          ref: "mainFilterPager",
          attrs: { receivesFocus: true },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "nti-product-tile-grid__container" },
      [
        _vm._l(_vm.productCards, function (data) {
          return [
            data
              ? _c("ProductTile", { key: data.id, attrs: { cardData: data } })
              : _vm._e(),
          ]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "section",
      {
        staticClass:
          "nti-product-tile-grid__navigation-container nti-product-tile-grid__navigation-container--bottom",
      },
      [_c("FilterPager")],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }